import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {QrTotemConfiguration} from '../models/QrTotemConfiguration';
import {BaseResponse} from '../models/response/BaseResponse';
import {HttpService} from './http.service';

@Injectable({
  providedIn: 'root'
})
export class QrTotemConfigurationService extends HttpService {

  lookup(deviceToken: string): Observable<BaseResponse<QrTotemConfiguration | null>> {
    return this.post('qr-totem-configuration/lookup', {
      device_token: deviceToken,
    });
  }
}
